var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.name)?_c('div',[_c('MainRender',{attrs:{"name":_vm.name}})],1):_c('div',[_c('input',{attrs:{"type":"text","placeholder":"Your name"},on:{"blur":_vm.setName}}),_c('button',[_vm._v("Go")]),_c('div',[_vm._v("\n      "+_vm._s(_vm.name)+"\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }